module.exports = __webpack_public_path__ + "img/WeekendClip.0c8b16db.png";